export default "__VITE_ASSET__vXO5Yr67__"